import React from "react"

import { ChipVariant } from "shared/ui/chip/Chip"
import { Skeleton } from "shared/ui/skeleton/Skeleton"
import { LoadingTags } from "shared/ui/tags/LoadingTags"

import "../../styles/_installation-reference-selection.scss"

export const LoadingInstallationReferenceCard = React.memo(() => (
  <div className="card card--elevated installation-reference-card loading">
    <div className="installation-reference-card__images loading">
      <div className="installation-reference-card__room-image">
        <Skeleton containerClassName="loading-image" />
      </div>
      <div className="installation-reference-card__detail-image">
        <Skeleton containerClassName="loading-image" />
      </div>
    </div>
    <div className="installation-reference-card__content">
      <div className="installation-reference-card__title loading">
        <Skeleton />
      </div>

      <LoadingTags
        amount={3}
        className="installation-reference-card__tags loading"
        chipStyle={ChipVariant.INFO}
      />
    </div>
  </div>
))
